export const THEME_CONSTANTS = {
    CHANGE_DEVICE_WIDTH: 'THEME_CHANGE_DEVICE_WIDTH',
    CHANGE_THEME: 'THEME_CHANGE_THEME',
    CHANGE_DRAWER: 'THEME_CHANGE_DRAWER_STATE',
};

export const handleChangeDeviceWidth = payload => dispatch => {
    dispatch({
        type: THEME_CONSTANTS.CHANGE_DEVICE_WIDTH,
        payload: {
            ...payload,
            layoutSet: true
        }
    })
}

export const handleChangeDrawerState = payload => dispatch => {
    dispatch({
        type: THEME_CONSTANTS.CHANGE_DRAWER,
        payload: payload
    })
}

export const handleChangeTheme = payload => dispatch => {
    dispatch({
        type: THEME_CONSTANTS.CHANGE_THEME,
        payload: payload
    })
}